import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import * as Redux from 'redux'
import * as Image from '../../../components/image'
import * as Modal from '../../../components/modal'
import * as Request from '../../../request'
import * as CommunityConfig from '../../community-config'
import * as NewsbriefConstants from '../constants'
import * as NewsbriefTypes from '../types'
import * as NewsbriefUtils from '../utils'
import * as Constants from './constants'

const logoReducerEvent: Modal.ReducerEvent<Image.ModalImageData> = {
  initializeState: () => Image.emptyModalImageData,
  requestEvent: Constants.LOGO_IMPORT,
}

type LogoAction = NewsbriefTypes.UpdateStateAction &
                  Request.RequestAction<Image.ModalImageData> &
                  Request.SuccessAction &
                  CommunityConfig.CommunityConfigRecievedAction

export const dataReducer = (
  state: NewsbriefTypes.CommunityConfigurationState = null, action: LogoAction) => {
  switch (action.type) {
    case Request.requestConstant(NewsbriefConstants.FETCH_COMMUNITY_CONFIG):
      return null
    case Request.successConstant(NewsbriefConstants.FETCH_COMMUNITY_CONFIG):
      const configs = CommunityConfig.configsFromResponse(action.payload.response)
      return NewsbriefUtils.payloadDataToState(configs, Constants.ALL_KEYS)
    case Constants.UPDATE_HEADER_LINK_URL:
      return NewsbriefUtils.updateState(state, action)
    case Constants.ADD_HEADER_LINK_URL:
      return NewsbriefUtils.addState(state, action)
    case Request.successConstant(Constants.LOGO_IMPORT):
      const updateAction: NewsbriefTypes.UpdateStateAction = {
        name: Constants.HEADER_IMAGE_URL,
        partnerCode: get(action.requestAction.options.payload, 'partnerCode'),
        property: 'value',
        rowId: get(action.requestAction.options.payload, 'rowId'),
        value: action.payload.response.image_url,
      }
      if ( isEmpty(updateAction.rowId) ) {
        return NewsbriefUtils.addState(state, updateAction)
      } else {
        return NewsbriefUtils.updateState(state, updateAction)
      }
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  data: dataReducer,
  modal: Image.reducer(logoReducerEvent),
})



// WEBPACK FOOTER //
// ./src/pages/newsbrief/logo/reducer.ts